<template lang="pug">
v-container
  div
    v-responsive
      v-data-table(:items='computedConsumerLoans' :headers='headers' dense :loading='indexLoading' single-expand :footer-props="{\
      'items-per-page-options': [5, 10, 15, 20],\
      }")
        template(v-slot:top)
          div
            v-row
              v-col(cols='12')
                v-text-field(label='Search' clearable hide-details single-line v-model='search' append-icon='mdi-magnify')
        template(v-slot:item='{ item, expand, isExpanded }')
          tr
            td
              div(class="config")
                v-tooltip(bottom v-if="authPermissions.has('consumer_loans:delete')")
                  template(v-slot:activator='{ on, attrs }')
                    v-icon(dark v-bind='attrs' v-on='on' color='error' @click='destroy(item.id)') mdi-delete
                  span Delete
                //- base-tooltip(
                //-   color='error'
                //-   dark
                //-   x-small
                //-   text
                //-   tooltip='Delete'
                //-   bottom
                //-   :loading="consumerLoanDeleting"
                //-   @click='destroy(item.id)'
                //- )
                //-   v-icon mdi-delete
                v-tooltip(bottom v-if="authPermissions.has('consumer_loans:edit')")
                  template(v-slot:activator='{ on, attrs }')
                    v-icon(dark v-bind='attrs' v-on='on' color='yellow' @click='editLoan(item)') mdi-pencil
                  span Edit Loan
                v-tooltip(bottom)
                  template(v-slot:activator='{ on, attrs }')
                    v-icon(dark v-bind='attrs' v-on='on' color='green' @click='toConsumerLoanInventories(item)') mdi-clipboard-multiple
                  span List of Loaned Goods
                div(v-if="authPermissions.has('consumer_loans:create')")
                  v-tooltip(bottom v-if='item.debt > 0')
                    template(v-slot:activator='{ on, attrs }')
                      v-icon(dark  v-bind='attrs' v-on='on' color='green' @click='toConsumerLoanTransactions(item)') mdi-account-cash
                    span Loan Payments
                  v-tooltip(bottom v-else)
                    template(v-slot:activator='{ on, attrs }')
                      v-icon(dark v-bind='attrs' v-on='on' color='gray') mdi-account-cash
                    span No Balance to Pay
                v-tooltip(bottom)
                  template(v-slot:activator='{ on, attrs }')
                    div
                      v-progress-circular(
                        v-if="printingPDF[item.id]"
                        color="error" 
                        :size="20" 
                        indeterminate 
                      )
                      v-icon(
                        v-else 
                        dark 
                        v-bind='attrs' 
                        v-on='on' 
                        color='error' 
                        @click='printReceipt(item)'
                      ) mdi-file
                  span Print Receipt
                v-tooltip(bottom)
                  template(v-slot:activator='{ on, attrs }')
                    v-icon(dark v-bind='attrs' v-on='on' color='green' @click='expand(!isExpanded)') {{ isExpanded ? 'mdi-minus' : 'mdi-plus' }}
                  span Expand
            td(:class='remarksColor(item.remarks)') {{ item.id }}
            td(:class='remarksColor(item.remarks)') {{ item.loanee_name }}
            td(:class='remarksColor(item.remarks)') {{ dateFormat(item.date_loaned) }}
            td(:class='remarksColor(item.remarks)') {{ dateFormat(item.date_due) }}
            td(:class='remarksColor(item.remarks)' style='text-align: right') {{ formatMoney(item.balance) }}
            td(:class='remarksColor(item.remarks)' style='text-align: right') {{ formatMoney(item.balance) }}
            th(:class='`${statusColor(item.debt, item.paid)}--text`')
              div(v-if='item.debt === 0') No Loan's Listed
              div(v-else)
                | {{ formatMoney(100 * (item.paid / item.debt)) }}% Paid
            td(:class='remarksColor(item.remarks)')
              strong {{ item.remarks ? 'Overdue' : '' }}
        template(v-slot:expanded-item='{ item }')
          td(colspan='6')
            v-row.ma-0
              v-col.py-0.border-bottom(cols='4' style='text-align: center') Amount
              v-col.py-0.border-bottom(cols='4' style='text-align: center') Status
              v-col.py-0.border-bottom(cols='4' style='text-align: center') REMARKS / SIGNATURE
            v-row.ma-0
              v-col(cols='4' :class="remarksColor(item.remarks) + ' py-0 border-right'")
                | {{ formatMoney(item.debt) }}
              v-col(cols='4' :class="`${statusColor(item.debt, item.paid)}--text` + ' py-0 border-right'")
                div(v-if='item.debt === 0') No Loan's Listed
                div(v-else)
                  strong {{ formatMoney(100 * (item.paid / item.debt)) }}% Paid
              v-col(cols='4' :class="remarksColor(item.remarks) + ' py-0'")
                strong {{ item.remarks ? 'Overdue' : '' }}
</template>
<style lang="scss" scoped>
.config {
  display: flex;

  .v-icon {
    margin-right: 5px;
  }

  .v-icon:last-child {
    margin-right: 0px;
  }
}
</style>
<script>
import consumerLoan from '@/repositories/consumer-loan.repository'
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
import { mapState } from 'vuex'
import searchDelay from '@/extra-functions/searchDelay.extra'
import Receipt from '@/pdf/receipt.pdf'
import { formatAccounting } from '@/lib/utils'

const searching = searchDelay()
const [consumerLoanDeleteVars, consumerLoanDeleteVarNames] = requestVars({ identifier: 'consumer-loan', hasData: false, request: 'delete' })
const consumerLoanDeleteHandler = new VueRequestHandler(null, consumerLoanDeleteVarNames)
function setDateZeroTime(date) {
  return new Date(new Date(date).setHours(0, 0, 0, 0))
}

function overDueRemark(date1, date2 = '', balance, id) {
  const dateNow = new Date(new Date().setHours(0, 0, 0, 0))
  const dateDue = setDateZeroTime(date1)
  const datePaid = !date2 ? null : setDateZeroTime(date2)
  let ret = false
  if (balance > 0 && dateDue < dateNow) {
    ret = true
  } else if (datePaid) {
    if (datePaid <= dateDue || dateDue >= dateNow) {
      ret = false
    } else if (datePaid > dateDue) {
      ret = true
    }
  }
  return ret
}

function consumerLoansMap(e) {
  const balance = e.debt - e.paid
  const remarks = overDueRemark(e.date_due, e.date_paid, balance, e.id)
  return {
    ...e,
    balance,
    remarks,
  }
}

export default {
  name: 'index-consumer-loan',
  props: {
    propConsumerId: String,
  },
  created() {
    this.getConsumerLoans()
    this.initWebsocketEvents()
  },
  beforeDestroy() {
    this.websocketEvents.forEach(eventId => {
      this.$store.dispatch('websocket/detachFromListener', [eventId])
    })
    this.websocketEvents = []
  },
  data() {
    return {
      ...consumerLoanDeleteVars,
      consumerLoans: [],
      indexLoading: false,
      printingPDF: {},
      search: null,
      headers: [
        { text: 'Config', sortable: false },
        { text: 'CR Number', value: 'id', sortable: false },
        { text: 'Name', value: 'loanee_name', sortable: true },
        { text: 'Date Of Reciept', value: 'date_loaned', sortable: true },
        { text: 'Date Due', value: 'date_due' },
        { text: 'Balance', sortable: false },
        // { text: 'Balance', sortable: false },
        // { text: 'Status', sortable: false },
        // { text: 'REMARKS/SIGNATURE' },
      ],
      websocketEvents: [],
    }
  },
  computed: {
    ...mapState({
      consumerLoanUpdated: state => state.consumerLoan.channelUpdate,
      storeId: state => state.settings.storeId,
      authPermissions: state => state.auth.userPermissions,
    }),
    computedConsumerLoans() {
      return this.consumerLoans.map(consumerLoansMap).sort((a, b) => (b.debt - b.paid) - (a.debt - a.paid))
    },
  },
  watch: {
    consumerLoanUpdated() {
      this.getConsumerLoans()
    },
    search() {
      searching(() => {
        this.getConsumerLoans()
      })
    },
  },
  methods: {
    async printReceipt(item) {
      try {
        if (this.printingPDF[item.id]) return
        this.printingPDF = { ...this.printing, [item.id]: true }
        const {
          data: {
            consumer_loan_inventory: consumerLoanInventory = [],
            consumer_loan_transaction: consumerLoanTransaction = [],
            id: receiptNo = '',
            loanee_name: customerName = '',
          },
        } = await consumerLoan.receipt({ consumer: item.consumer_id, consumerLoan: item.id })

        const amountPaid = consumerLoanTransaction.reduce((prev, next) => prev + Number(next?.amount_paid), 0)

        let totalAmount = 0

        const items = consumerLoanInventory.map(item => {
          const amount = Number(item?.quantity) * (Number(item?.retail)) - Number(item?.discount)
          totalAmount += amount
          return {
            item: `${item?.stock?.product_name} (${item?.stock?.stock_code})`,
            quantity: item.quantity,
            price: formatAccounting(item.retail),
            discount: formatAccounting(item.discount),
            amount: formatAccounting(amount),
          }
        })

        const receipt = new Receipt()

        const balance = totalAmount - amountPaid

        receipt.generate({
          totalAmount,
          amountPaid,
          balance,
          receiptNo,
          name: customerName,
        }, items)
      } catch (err) {
        alert(err.message)
      } finally {
        this.printingPDF = Object.keys(this.printingPDF)
          .filter(key => key !== item.id)
          .reduce((prev, key) => {
            prev[key] = this.printingPDF[key]
            return prev
          }, {})
      }
    },
    async initWebsocketEvents() {
      const dbStoreEventId = await this.$store.dispatch('websocket/attachToListener', ['DBStoreEvent', this.getConsumerLoans])
      const dbUpdateEventId = await this.$store.dispatch('websocket/attachToListener', ['DBUpdateEvent', this.getConsumerLoans])
      const dbDeleteEventId = await this.$store.dispatch('websocket/attachToListener', ['DBDeleteEvent', this.getConsumerLoans])
      this.websocketEvents.push(dbStoreEventId, dbUpdateEventId, dbDeleteEventId)
    },
    removeCrNumber(id) {
      this.consumerLoans = this.consumerLoans.filter(item => item.id !== id)
    },
    async getConsumerLoans() {
      this.indexLoading = true
      consumerLoan.index(this.propConsumerId, { storeId: this.storeId, search: this.search })
        .then(({ data }) => { this.consumerLoans = data.sort((a, b) => (b.debt - b.paid) - (a.debt - a.paid)) })
        .catch(e => { })
        .then(() => { this.indexLoading = false })
    },
    destroy(id) {
      this.$confirm('are you sure you want to permanently remove this data?')
        .then(confirm => {
          if (!confirm) return
          const handler = consumerLoanDeleteHandler
          const repository = consumerLoan.delete
          handler.setVue(this)
          handler.execute(repository, [id])
        })
    },
    dateFormat(d) {
      const date = new Date(d)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')
      return `${month}/${day}/${year}`
    },
    editLoan(item) {
      this.$emit('edit', item)
    },
    toConsumerLoanInventories({ id }) {
      const params = {
        consumer: this.propConsumerId,
        consumerLoan: id,
      }
      this.$router.push({ name: 'Consumer.Loan.Inventories', params })
    },
    toConsumerLoanTransactions({ id }) {
      const params = {
        consumer: this.propConsumerId,
        consumerLoan: id,
      }
      this.$router.push({ name: 'Consumer.Loan.Transactions', params })
    },
    remarksColor(remarks) {
      return !remarks ? '' : 'red--text'
    },
    statusColor(debt, paid) {
      let ret = 'primary'
      if (debt > 0) {
        const percentage = 100 * (paid / debt)
        if (percentage < 20) {
          ret = 'red'
        } else if (percentage < 40) {
          ret = 'orange'
        } else if (percentage < 70) {
          ret = 'yellow'
        } else {
          ret = 'green'
        }
      }
      return ret
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
<style lang="scss" scoped>
.c-width {
  max-width: 200px;
}

.border-right {
  border-right: 1px lightgray solid;
}

.border-bottom {
  border-bottom: 1px lightgray solid;
}
</style>
